import { setDefaults as i } from "./index47.mjs";
var r = {
  type: "3rdParty",
  init: function(t) {
    i(t.options.react);
  }
};
export {
  r as initReactI18next
};
